import React from "react";
import SectionHeader from "../Common/Section-Header/SectionHeader";
import BlogCard from "./Blog-Card/BlogCard";
import Fade from "react-reveal/Fade";
import "./Blog.scss";
import BlogPosts from "data/blogs.json";

const Blog = () => {
  const blogPostsWithId = BlogPosts.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  return (
    <section className="section-separator" id="blog">
      <div className="container mb-5">
        <Fade bottom>
          <SectionHeader subtitle="Latest writings" title="My Blog" />
        </Fade>
        <div className="row mt-2">
          {blogPostsWithId.map((post) => (
            <BlogCard
              key={post.id}
              title={post.title}
              author={post.author}
              date={post.date}
              image={post.thumbnail}
              link={post.link}
            />
          ))}
        </div>
        <Fade bottom>
          <div className="mt-5 text-center">
            <a
              href="https://nandundiaz.blogspot.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn-main">View More</button>
            </a>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default Blog;
